<template>
  <section id="_" class="features_area pt-45">
      <div
        id="sliderCarousel"
        class="carousel slide main-slider slider"
        data-ride="carousel">
        <div class="carousel-inner">
          <div class="slider-item carousel-item active">
            <div class="gallery-cell" style="position: relative; text-align: center;">
              <img src="assets/images/5.jpg" alt="" style="width: 100%;"/>
              <div class="centered">
                  <p data-wow-duration="1.3s" data-wow-delay="0.7" class="title wow fadeInDown text-color-light header-text" style="font-weight: lighter;">SELAMAT DATANG DI TJSL KAI</p>
                  <p data-wow-duration="1.3s" data-wow-delay="0.8s" class="title wow fadeInUp text-color-light subheader-text" style="margin-top: 13px;">PT KERETA API INDONESIA (Persero)</p>
                  <p data-wow-duration="1.3s" data-wow-delay="1.3s" class="title wow fadeInUp text-color-light subtitle-text" style="margin-top: 17px;">
                    Komitmen Perusahaan untuk berperan serta dalam pembangunan ekonomi berkelanjutan guna meningkatkan kualitas kehidupan dan lingkungan yang bermanfaat melalui Program Kemitraan, Program Bina Lingkungan, dan Community Relations.
                  </p>
              </div>
            </div>
          </div>
          <div class="slider-item carousel-item">
            <div class="gallery-cell" style="position: relative; text-align: center;margin-top: 2%;">
              <img src="assets/images/slide-1.jpg" alt="" style="width: 100%;height: 100%;"/>
            </div>
          </div>
          <div class="slider-item carousel-item">
            <div class="gallery-cell" style="position: relative; text-align: center;margin-top: 2%;">
              <img src="assets/images/slide-2.jpg" alt="" style="width: 100%;height: 100%;"/>
            </div>
          </div>
          <div class="slider-item carousel-item">
            <div class="gallery-cell" style="position: relative; text-align: center;margin-top: 2%;">
              <img src="assets/images/slide-3.jpg" alt="" style="width: 100%;height: 100%;"/>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#sliderCarousel"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#sliderCarousel"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
  </section>
</template>
<style>
.centered {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text-color-light {
  color: white;
}
.text-color-dark {
  color: black;
}

.header-text {
    font-size: 1.5rem
}

.subheader-text {
  font-size: 2.3rem
}

.subtitle-text{
  font-size: 1.1rem;
}

@media screen and (max-width: 600px) {
  .header-text {
    font-size: 0.8rem
  }

  .subheader-text {
    font-size: 1.5rem
  }

  .subtitle-text{
    font-size: 0.2rem;
  }
}

</style>
